import Popup from './popup';

const successPopupElement = document.querySelector('.sent--success');
const successPopupCloseBtn = successPopupElement.querySelector('.sent__btn');

const errorPopupElement = document.querySelector('.sent--error');
const errorPopupCloseBtn = errorPopupElement.querySelector('.sent__btn');

const successPopup = new Popup(successPopupElement);
const errorPopup = new Popup(errorPopupElement);

successPopupCloseBtn.addEventListener('click', () => {
  successPopup.close();
});

errorPopupCloseBtn.addEventListener('click', () => {
  errorPopup.close();
});

const initForm = (formElement) => {
  const path = formElement.action;
  const inputElement = formElement.querySelector('input');
  const btnElement = formElement.querySelector('button');

  const lockForm = () => {
    inputElement.disabled = true;
    btnElement.disabled = true;
  };

  const unlockForm = () => {
    inputElement.disabled = false;
    btnElement.disabled = false;
  };

  const sendData = () => {
    const XHR = new XMLHttpRequest();
    const formData = new FormData();

    formData.append('email', inputElement.value);

    XHR.onreadystatechange = () => {
      if (XHR.readyState === 4) {
        if (XHR.response === 'OK') {
          unlockForm();
          successPopup.open();
        } else {
          unlockForm();
          errorPopup.open();
        }
      }
    };

    // XHR.addEventListener('load', () => {});

    // XHR.addEventListener('error', () => {});

    XHR.open('POST', path);

    XHR.send(formData);
  };

  const onFormSubmit = (evt) => {
    evt.preventDefault();
    lockForm();
    sendData();
  };

  formElement.addEventListener('submit', onFormSubmit);
};

export default initForm;
